import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { useProvince } from "@/contexts/ProvinceContext";
import { Map as MapIcon, Search } from "lucide-react";

export default function CityGuideBlock() {
  const { selected } = useProvince();
  const [items, setItems] = useState([]);
  useEffect(() => {
    if (!selected?.id) return;
    api.get(`/city-guide?province_id=${selected.id}&limit=6`).then((r) => setItems(r.data.items || [])).catch(() => {});
  }, [selected?.id]);
  return (
    <div className="w-full bg-gradient-to-br from-[#0b0b0d] to-[#1f1f24] text-white rounded-lg p-6">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <MapIcon className="w-5 h-5 text-[#e11d2a]" />
          <h3 className="text-lg font-black">{selected?.name?.toUpperCase() || "ŞEHİR"} REHBERİ</h3>
        </div>
        <Link to="/sehir-rehberi" className="text-xs font-semibold text-[#e11d2a] hover:text-white">Rehberi Aç →</Link>
      </div>
      <p className="text-sm text-gray-300 mb-4">Şehrinizin restoran, kurum, hizmet ve işletmelerini keşfedin. Tüm bilgiler harita üzerinden erişilebilir.</p>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-2">
        {items.slice(0, 6).map((e) => (
          <Link key={e.id} to="/sehir-rehberi" className="bg-white/5 hover:bg-white/10 rounded p-2 text-xs">
            <div className="text-[10px] uppercase text-[#e11d2a] font-bold">{e.category}</div>
            <div className="font-medium line-clamp-1">{e.name}</div>
          </Link>
        ))}
      </div>
    </div>
  );
}
